// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"recorder":"5108dac990f51ee3","profiler":"d5d4b2dd21798aad"}[chunkId] + ".js";
};